import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";

import { environment } from "../../environments/environment";

/**
 * Interceptor that adds the X-App-Key header to all requests sent to viewerUrl.
 */
@Injectable()
export class AppKeyInterceptor implements HttpInterceptor {
  /**
   * Intercepts HTTP requests and adds the X-App-Key header if the URL matches environment.viewerUrl.
   *
   * @param request - The HTTP request
   * @param next - The next HTTP handler
   * @returns Observable of the HTTP event
   */
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const headers = {};
    if (request.url.startsWith(environment.viewerUrl)) {
      if (environment.appKey) {
        headers["X-App-Key"] = environment.appKey;
      }
      if (environment.appFlavour) {
        headers["X-Flavor-Key"] = environment.appFlavour;
      }
    }
    if (headers) {
      const cloned = request.clone({
        setHeaders: headers,
      });
      return next.handle(cloned);
    }
    return next.handle(request);
  }
}
